// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,json_types=true"
// @generated from file pages/v2/component.proto (package pages.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { VersionIncrement, VersionIncrementJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Page, PageJson } from "./page_pb";
import { file_pages_v2_page } from "./page_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file pages/v2/component.proto.
 */
export const file_pages_v2_component: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_asset_v1_asset, file_common_v1_annotations, file_google_api_annotations, file_google_protobuf_struct, file_google_protobuf_timestamp, file_pages_v2_page],
	);

/**
 * @generated from message pages.v2.ComponentDef
 */
export type ComponentDef = Message<"pages.v2.ComponentDef"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string type_uri = 4;
	 */
	typeUri: string;

	/**
	 * @generated from field: string component_type = 5;
	 */
	componentType: string;

	/**
	 * @generated from field: string editor_component_type = 6;
	 */
	editorComponentType: string;

	/**
	 * @generated from field: string remote_url = 7;
	 */
	remoteUrl: string;

	/**
	 * @generated from field: string internal_remote_url = 14;
	 */
	internalRemoteUrl: string;

	/**
	 * @generated from field: string thumbnail_image = 8;
	 */
	thumbnailImage: string;

	/**
	 * @generated from field: bool is_container = 9;
	 */
	isContainer: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 10;
	 */
	schema?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct default_sytyle = 11;
	 */
	defaultSytyle?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: bool is_connectable = 15;
	 */
	isConnectable: boolean;

	/**
	 * @generated from field: bool connection_required = 16;
	 */
	connectionRequired: boolean;

	/**
	 * @generated from field: string display_name = 17;
	 */
	displayName: string;
};

/**
 * @generated from message pages.v2.ComponentDef
 */
export type ComponentDefJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string type_uri = 4;
	 */
	typeUri?: string;

	/**
	 * @generated from field: string component_type = 5;
	 */
	componentType?: string;

	/**
	 * @generated from field: string editor_component_type = 6;
	 */
	editorComponentType?: string;

	/**
	 * @generated from field: string remote_url = 7;
	 */
	remoteUrl?: string;

	/**
	 * @generated from field: string internal_remote_url = 14;
	 */
	internalRemoteUrl?: string;

	/**
	 * @generated from field: string thumbnail_image = 8;
	 */
	thumbnailImage?: string;

	/**
	 * @generated from field: bool is_container = 9;
	 */
	isContainer?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 10;
	 */
	schema?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct default_sytyle = 11;
	 */
	defaultSytyle?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: bool is_connectable = 15;
	 */
	isConnectable?: boolean;

	/**
	 * @generated from field: bool connection_required = 16;
	 */
	connectionRequired?: boolean;

	/**
	 * @generated from field: string display_name = 17;
	 */
	displayName?: string;
};

/**
 * Describes the message pages.v2.ComponentDef.
 * Use `create(ComponentDefSchema)` to create a new message.
 */
export const ComponentDefSchema: GenMessage<ComponentDef, { jsonType: ComponentDefJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 0);

/**
 * @generated from message pages.v2.GetComponentsRequest
 */
export type GetComponentsRequest = Message<"pages.v2.GetComponentsRequest"> & {
	/**
	 * @generated from field: repeated string type_uris = 1;
	 */
	typeUris: string[];
};

/**
 * @generated from message pages.v2.GetComponentsRequest
 */
export type GetComponentsRequestJson = {
	/**
	 * @generated from field: repeated string type_uris = 1;
	 */
	typeUris?: string[];
};

/**
 * Describes the message pages.v2.GetComponentsRequest.
 * Use `create(GetComponentsRequestSchema)` to create a new message.
 */
export const GetComponentsRequestSchema: GenMessage<GetComponentsRequest, { jsonType: GetComponentsRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 1);

/**
 * @generated from message pages.v2.GetComponentsResponse
 */
export type GetComponentsResponse = Message<"pages.v2.GetComponentsResponse"> & {
	/**
	 * @generated from field: repeated pages.v2.ComponentDef definitions = 1;
	 */
	definitions: ComponentDef[];
};

/**
 * @generated from message pages.v2.GetComponentsResponse
 */
export type GetComponentsResponseJson = {
	/**
	 * @generated from field: repeated pages.v2.ComponentDef definitions = 1;
	 */
	definitions?: ComponentDefJson[];
};

/**
 * Describes the message pages.v2.GetComponentsResponse.
 * Use `create(GetComponentsResponseSchema)` to create a new message.
 */
export const GetComponentsResponseSchema: GenMessage<GetComponentsResponse, { jsonType: GetComponentsResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 2);

/**
 * @generated from message pages.v2.GetComponentRequest
 */
export type GetComponentRequest = Message<"pages.v2.GetComponentRequest"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message pages.v2.GetComponentRequest
 */
export type GetComponentRequestJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message pages.v2.GetComponentRequest.
 * Use `create(GetComponentRequestSchema)` to create a new message.
 */
export const GetComponentRequestSchema: GenMessage<GetComponentRequest, { jsonType: GetComponentRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 3);

/**
 * @generated from message pages.v2.GetComponentResponse
 */
export type GetComponentResponse = Message<"pages.v2.GetComponentResponse"> & {
	/**
	 * @generated from field: pages.v2.ComponentDef definition = 1;
	 */
	definition?: ComponentDef | undefined;
};

/**
 * @generated from message pages.v2.GetComponentResponse
 */
export type GetComponentResponseJson = {
	/**
	 * @generated from field: pages.v2.ComponentDef definition = 1;
	 */
	definition?: ComponentDefJson;
};

/**
 * Describes the message pages.v2.GetComponentResponse.
 * Use `create(GetComponentResponseSchema)` to create a new message.
 */
export const GetComponentResponseSchema: GenMessage<GetComponentResponse, { jsonType: GetComponentResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 4);

/**
 * @generated from message pages.v2.RegisterComponentRequest
 */
export type RegisterComponentRequest = Message<"pages.v2.RegisterComponentRequest"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string component_type = 4;
	 */
	componentType: string;

	/**
	 * @generated from field: string editor_component_type = 5;
	 */
	editorComponentType: string;

	/**
	 * @generated from field: string remote_url = 6;
	 */
	remoteUrl: string;

	/**
	 * @generated from field: string internal_remote_url = 11;
	 */
	internalRemoteUrl: string;

	/**
	 * @generated from field: string thumbnail_image = 7;
	 */
	thumbnailImage: string;

	/**
	 * @generated from field: bool is_container = 8;
	 */
	isContainer: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 9;
	 */
	schema?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct default_style = 10;
	 */
	defaultStyle?: JsonObject | undefined;

	/**
	 * @generated from field: bool is_connectable = 12;
	 */
	isConnectable: boolean;

	/**
	 * @generated from field: bool connection_required = 13;
	 */
	connectionRequired: boolean;

	/**
	 * @generated from field: string display_name = 14;
	 */
	displayName: string;
};

/**
 * @generated from message pages.v2.RegisterComponentRequest
 */
export type RegisterComponentRequestJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string component_type = 4;
	 */
	componentType?: string;

	/**
	 * @generated from field: string editor_component_type = 5;
	 */
	editorComponentType?: string;

	/**
	 * @generated from field: string remote_url = 6;
	 */
	remoteUrl?: string;

	/**
	 * @generated from field: string internal_remote_url = 11;
	 */
	internalRemoteUrl?: string;

	/**
	 * @generated from field: string thumbnail_image = 7;
	 */
	thumbnailImage?: string;

	/**
	 * @generated from field: bool is_container = 8;
	 */
	isContainer?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 9;
	 */
	schema?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct default_style = 10;
	 */
	defaultStyle?: StructJson;

	/**
	 * @generated from field: bool is_connectable = 12;
	 */
	isConnectable?: boolean;

	/**
	 * @generated from field: bool connection_required = 13;
	 */
	connectionRequired?: boolean;

	/**
	 * @generated from field: string display_name = 14;
	 */
	displayName?: string;
};

/**
 * Describes the message pages.v2.RegisterComponentRequest.
 * Use `create(RegisterComponentRequestSchema)` to create a new message.
 */
export const RegisterComponentRequestSchema: GenMessage<RegisterComponentRequest, { jsonType: RegisterComponentRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 5);

/**
 * @generated from message pages.v2.RegisterComponentResponse
 */
export type RegisterComponentResponse = Message<"pages.v2.RegisterComponentResponse"> & {
	/**
	 * @generated from field: pages.v2.ComponentDef definition = 1;
	 */
	definition?: ComponentDef | undefined;
};

/**
 * @generated from message pages.v2.RegisterComponentResponse
 */
export type RegisterComponentResponseJson = {
	/**
	 * @generated from field: pages.v2.ComponentDef definition = 1;
	 */
	definition?: ComponentDefJson;
};

/**
 * Describes the message pages.v2.RegisterComponentResponse.
 * Use `create(RegisterComponentResponseSchema)` to create a new message.
 */
export const RegisterComponentResponseSchema: GenMessage<RegisterComponentResponse, { jsonType: RegisterComponentResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 6);

/**
 * @generated from message pages.v2.CreateComponentRequest
 */
export type CreateComponentRequest = Message<"pages.v2.CreateComponentRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string source_asset_id = 5;
	 */
	sourceAssetId?: string | undefined;

	/**
	 * @generated from field: optional string source_asset_version = 6;
	 */
	sourceAssetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.CreateComponentRequest
 */
export type CreateComponentRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: StructJson;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string source_asset_id = 5;
	 */
	sourceAssetId?: string;

	/**
	 * @generated from field: optional string source_asset_version = 6;
	 */
	sourceAssetVersion?: string;
};

/**
 * Describes the message pages.v2.CreateComponentRequest.
 * Use `create(CreateComponentRequestSchema)` to create a new message.
 */
export const CreateComponentRequestSchema: GenMessage<CreateComponentRequest, { jsonType: CreateComponentRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 7);

/**
 * @generated from message pages.v2.CreateComponentResponse
 */
export type CreateComponentResponse = Message<"pages.v2.CreateComponentResponse"> & {
	/**
	 * @generated from field: optional string asset_id = 2;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 3;
	 */
	assetVersion?: string | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.CreateComponentResponse
 */
export type CreateComponentResponseJson = {
	/**
	 * @generated from field: optional string asset_id = 2;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 3;
	 */
	assetVersion?: string;

	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.CreateComponentResponse.
 * Use `create(CreateComponentResponseSchema)` to create a new message.
 */
export const CreateComponentResponseSchema: GenMessage<CreateComponentResponse, { jsonType: CreateComponentResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 8);

/**
 * @generated from message pages.v2.UpdateComponentRequest
 */
export type UpdateComponentRequest = Message<"pages.v2.UpdateComponentRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct new_config = 3;
	 */
	newConfig?: JsonObject | undefined;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.UpdateComponentRequest
 */
export type UpdateComponentRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct new_config = 3;
	 */
	newConfig?: StructJson;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.UpdateComponentRequest.
 * Use `create(UpdateComponentRequestSchema)` to create a new message.
 */
export const UpdateComponentRequestSchema: GenMessage<UpdateComponentRequest, { jsonType: UpdateComponentRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 9);

/**
 * @generated from message pages.v2.UpdateComponentResponse
 */
export type UpdateComponentResponse = Message<"pages.v2.UpdateComponentResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.UpdateComponentResponse
 */
export type UpdateComponentResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.UpdateComponentResponse.
 * Use `create(UpdateComponentResponseSchema)` to create a new message.
 */
export const UpdateComponentResponseSchema: GenMessage<UpdateComponentResponse, { jsonType: UpdateComponentResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 10);

/**
 * @generated from message pages.v2.GetDataRequest
 */
export type GetDataRequest = Message<"pages.v2.GetDataRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: pages.v2.Page parent = 5;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 3;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 4;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.GetDataRequest
 */
export type GetDataRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: pages.v2.Page parent = 5;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 3;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 4;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.GetDataRequest.
 * Use `create(GetDataRequestSchema)` to create a new message.
 */
export const GetDataRequestSchema: GenMessage<GetDataRequest, { jsonType: GetDataRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 11);

/**
 * @generated from message pages.v2.GetDataResponse
 */
export type GetDataResponse = Message<"pages.v2.GetDataResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.GetDataResponse
 */
export type GetDataResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.GetDataResponse.
 * Use `create(GetDataResponseSchema)` to create a new message.
 */
export const GetDataResponseSchema: GenMessage<GetDataResponse, { jsonType: GetDataResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 12);

/**
 * @generated from message pages.v2.SaveDataRequest
 */
export type SaveDataRequest = Message<"pages.v2.SaveDataRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: bool validate_only = 4;
	 */
	validateOnly: boolean;

	/**
	 * @generated from field: pages.v2.Page parent = 5;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 6;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 7;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.SaveDataRequest
 */
export type SaveDataRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: StructJson;

	/**
	 * @generated from field: bool validate_only = 4;
	 */
	validateOnly?: boolean;

	/**
	 * @generated from field: pages.v2.Page parent = 5;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 6;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 7;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.SaveDataRequest.
 * Use `create(SaveDataRequestSchema)` to create a new message.
 */
export const SaveDataRequestSchema: GenMessage<SaveDataRequest, { jsonType: SaveDataRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 13);

/**
 * @generated from message pages.v2.SaveDataResponse
 */
export type SaveDataResponse = Message<"pages.v2.SaveDataResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.SaveDataResponse
 */
export type SaveDataResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.SaveDataResponse.
 * Use `create(SaveDataResponseSchema)` to create a new message.
 */
export const SaveDataResponseSchema: GenMessage<SaveDataResponse, { jsonType: SaveDataResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 14);

/**
 * @generated from message pages.v2.PostDataRequest
 */
export type PostDataRequest = Message<"pages.v2.PostDataRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: bool validate_only = 4;
	 */
	validateOnly: boolean;

	/**
	 * @generated from field: pages.v2.Page parent = 7;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.PostDataRequest
 */
export type PostDataRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 3;
	 */
	data?: StructJson;

	/**
	 * @generated from field: bool validate_only = 4;
	 */
	validateOnly?: boolean;

	/**
	 * @generated from field: pages.v2.Page parent = 7;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.PostDataRequest.
 * Use `create(PostDataRequestSchema)` to create a new message.
 */
export const PostDataRequestSchema: GenMessage<PostDataRequest, { jsonType: PostDataRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 15);

/**
 * @generated from message pages.v2.PostDataResponse
 */
export type PostDataResponse = Message<"pages.v2.PostDataResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.PostDataResponse
 */
export type PostDataResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.PostDataResponse.
 * Use `create(PostDataResponseSchema)` to create a new message.
 */
export const PostDataResponseSchema: GenMessage<PostDataResponse, { jsonType: PostDataResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 16);

/**
 * @generated from message pages.v2.CreateVersionRequest
 */
export type CreateVersionRequest = Message<"pages.v2.CreateVersionRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.CreateVersionRequest
 */
export type CreateVersionRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: pages.v2.Page parent = 4;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 5;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 6;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.CreateVersionRequest.
 * Use `create(CreateVersionRequestSchema)` to create a new message.
 */
export const CreateVersionRequestSchema: GenMessage<CreateVersionRequest, { jsonType: CreateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 17);

/**
 * @generated from message pages.v2.CreateVersionResponse
 */
export type CreateVersionResponse = Message<"pages.v2.CreateVersionResponse"> & {
	/**
	 * @generated from field: optional string asset_id = 3;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 4;
	 */
	assetVersion?: string | undefined;

	/**
	 * @generated from field: google.protobuf.Struct config = 1;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.CreateVersionResponse
 */
export type CreateVersionResponseJson = {
	/**
	 * @generated from field: optional string asset_id = 3;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 4;
	 */
	assetVersion?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 1;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.CreateVersionResponse.
 * Use `create(CreateVersionResponseSchema)` to create a new message.
 */
export const CreateVersionResponseSchema: GenMessage<CreateVersionResponse, { jsonType: CreateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 18);

/**
 * @generated from message pages.v2.PublishVersionRequest
 */
export type PublishVersionRequest = Message<"pages.v2.PublishVersionRequest"> & {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: pages.v2.Page parent = 3;
	 */
	parent?: Page | undefined;

	/**
	 * @generated from field: optional string asset_id = 4;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: optional string asset_version = 5;
	 */
	assetVersion?: string | undefined;
};

/**
 * @generated from message pages.v2.PublishVersionRequest
 */
export type PublishVersionRequestJson = {
	/**
	 * @generated from field: string type_uri = 1;
	 */
	typeUri?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: pages.v2.Page parent = 3;
	 */
	parent?: PageJson;

	/**
	 * @generated from field: optional string asset_id = 4;
	 */
	assetId?: string;

	/**
	 * @generated from field: optional string asset_version = 5;
	 */
	assetVersion?: string;
};

/**
 * Describes the message pages.v2.PublishVersionRequest.
 * Use `create(PublishVersionRequestSchema)` to create a new message.
 */
export const PublishVersionRequestSchema: GenMessage<PublishVersionRequest, { jsonType: PublishVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 19);

/**
 * @generated from message pages.v2.PublishVersionResponse
 */
export type PublishVersionResponse = Message<"pages.v2.PublishVersionResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message pages.v2.PublishVersionResponse
 */
export type PublishVersionResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct data = 1;
	 */
	data?: StructJson;
};

/**
 * Describes the message pages.v2.PublishVersionResponse.
 * Use `create(PublishVersionResponseSchema)` to create a new message.
 */
export const PublishVersionResponseSchema: GenMessage<PublishVersionResponse, { jsonType: PublishVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_pages_v2_component, 20);

/**
 * @generated from service pages.v2.ComponentService
 */
export const ComponentService: GenService<{
	/**
	 * @generated from rpc pages.v2.ComponentService.CreateComponent
	 */
	createComponent: {
		methodKind: "unary";
		input: typeof CreateComponentRequestSchema;
		output: typeof CreateComponentResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.UpdateComponent
	 */
	updateComponent: {
		methodKind: "unary";
		input: typeof UpdateComponentRequestSchema;
		output: typeof UpdateComponentResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.SaveData
	 */
	saveData: {
		methodKind: "unary";
		input: typeof SaveDataRequestSchema;
		output: typeof SaveDataResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.GetData
	 */
	getData: {
		methodKind: "unary";
		input: typeof GetDataRequestSchema;
		output: typeof GetDataResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.PostData
	 */
	postData: {
		methodKind: "unary";
		input: typeof PostDataRequestSchema;
		output: typeof PostDataResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.CreateVersion
	 */
	createVersion: {
		methodKind: "unary";
		input: typeof CreateVersionRequestSchema;
		output: typeof CreateVersionResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentService.PublishVersion
	 */
	publishVersion: {
		methodKind: "unary";
		input: typeof PublishVersionRequestSchema;
		output: typeof PublishVersionResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_pages_v2_component, 0);

/**
 * @generated from service pages.v2.ComponentRegistryService
 */
export const ComponentRegistryService: GenService<{
	/**
	 * @generated from rpc pages.v2.ComponentRegistryService.RegisterComponent
	 */
	registerComponent: {
		methodKind: "unary";
		input: typeof RegisterComponentRequestSchema;
		output: typeof RegisterComponentResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentRegistryService.GetComponents
	 */
	getComponents: {
		methodKind: "unary";
		input: typeof GetComponentsRequestSchema;
		output: typeof GetComponentsResponseSchema;
	};
	/**
	 * @generated from rpc pages.v2.ComponentRegistryService.GetComponent
	 */
	getComponent: {
		methodKind: "unary";
		input: typeof GetComponentRequestSchema;
		output: typeof GetComponentResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_pages_v2_component, 1);
